<div class="mb-80">
    <mapfre-header></mapfre-header>
</div>
<div class="bs-success">
    <div class="bs-success-screen">
        <div class="bs-success-content">
            <div class="bs-success-text-title bs-mobile">
                <div>{{"You have successfully enrolled your policy"}}</div>
                <div>{{'in paperless!'}}</div>
            </div>
            <div class="bs-success-man-bg-image"></div>
            <div class="bs-success-text">
                <div class="bs-success-text-title bs-desktop">
                    <div class="hide-below-1200">{{"You have successfully enrolled your policy in paperless!"}}</div>
                    <div class="hide-exceeds-1199">
                        <div>{{"You have successfully enrolled your policy"}}</div>
                        <div>{{'in paperless!'}}</div>
                    </div>
                </div>
                <div>
                    <div class="bs-success-activate">
                        <div>{{"Now activate your"}} </div>
                        <div class="bs-ml-6">{{"Mapfre Customer Account to:"}}</div>
                    </div>
                    <ul>
                        <li>View documents</li>
                        <li>Manage payments</li>
                        <li>Manage your policy</li>
                    </ul>
                </div>
                <div>
                    <a routerLink="/login"
                    class="basic h56 large-btn btn bs-success-btn link mapfre"               
                    >{{"Activate your account" | translate}}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="bs-success-sustain-card">
        <app-sustainability-card></app-sustainability-card>
    </div>
</div>
